import { render } from "./ElevatorChannelsPort.vue?vue&type=template&id=be8df57c&scoped=true"
import script from "./ElevatorChannelsPort.vue?vue&type=script&lang=js"
export * from "./ElevatorChannelsPort.vue?vue&type=script&lang=js"

import "./ElevatorChannelsPort.vue?vue&type=style&index=0&id=be8df57c&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8df57c"]])

export default __exports__